export const userTypes = {
  SET_AUTHENTICATED: "SET_AUTHENTICATED",
  SET_UNAUTHENTICATED: "SET_UNAUTHENTICATED",
  SET_USER: "SET_USER",
  LOADING: "LOADING_USER",
  MARK_NOTIFICATIONS_READ: "MARK_NOTIFICATIONS_READ"
};

export const uiTypes = {
  SET_ERRORS: "SET_ERRORS",
  SET_LOADING: "SET_LOADING_UI",
  STOP_LOADING: "STOP_LOADING",
  CLEAR_ERRORS: "CLEAR_ERRORS"
};

export const dataTypes = {
  SET_POSTS: "SET_POSTS",
  SET_POST: "SET_POST",
  LOADING: "LOADING_DATA",
  APPROVE_POST: "APPROVE_POST",
  DISAPPROVE_POST: "DISAPPROVE_POST",
  DELETE_POST: "DELETE_POST",
  ADD_POST: "ADD_POST",
  SET_COMMENTS: "SET_COMMENTS",
  SUBMIT_COMMENT: "SUBMIT_COMMENT",
  DELETE_COMMENT: "DELETE_COMMENT",
  SET_CURRENT_PROFILE: "SET_CURRENT_PROFILE",
  UNSET_CURRENT_PROFILE: "UNSET_CURRENT_PROFILE"
};
